module.exports = __webpack_public_path__ + "img/QR_Pay.14abb033.png";